import { useAuth } from 'react-oidc-context';
import { downloadManifestReport } from '../service/downloadManifestReport';
import { saveAs } from 'file-saver';
import showToast from './ToastComponent';

export function DownloadManifestSummary() {
  const { user } = useAuth();

  const handleDownloadManifestReportClick = async () => {
    if (!user?.access_token) {
      console.log('Access token not found');
      return;
    }

    const result = await downloadManifestReport(user.access_token);

    if (result.status === 200) {
      console.log(result.data);
      saveAs(result.data, 'manifest-report.pdf');
      return;
    }

    showToast({ type: 'error', message: 'Failed to download manifest report' });
  };

  return (
    <button
      className={`ml-4 text-xs border border-secondary-pink-600 rounded font-semibold text-secondary-pink-600 
bg-white px-3 py-2 hover:bg-secondary-pink-600 hover:text-white`}
      onClick={() => handleDownloadManifestReportClick()}
    >
      Download Manifest Report
    </button>
  );
}
